const css = require('./restore.css');
const SCHEMES = require('../../../helpers/scheme');
const { Text } = require('account-ui');
const Error = require('../error');
const { inputText, blurText } = require('../../../signals/form');
const signals = require('../../../signals/auth/restore-password');
const { cut } = require('../../../helpers/utils');
let { redirect } = require('../../../signals/utils');

const SUBMIT = cut(css.submit);

class Restore {
    constructor () {
        this.template = require('./template.hbs');
    }

    bind () {
        return {
            click: {
                [SUBMIT]: this.handleRestore,
                [cut(css.redirect)]: this.redirect
            }
        };
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }

    handleRestore () {
        this.$context.signal(signals.restore);
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }
}

module.exports = {
    constructor: Restore,
    children: [
        {
            name: 'text-email',
            component: Text,
            props: {
                signals: { inputText, blurText },
                placeholder: 'Email',
                position: 'leftToRight',
                scheme: SCHEMES.email
            },
            watcher: {
                value: ['restore', 'form', 'email'],
                error: ['restore', 'error', 'email']
            }
        },
        {
            name: 'error',
            component: Error,
            watcher: {
                isError: ['restore', 'computed', 'error', 'isError'],
                text: ['restore', 'computed', 'error', 'text']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/auth/restore/index.js